export const acceptableFiles = [
  "image/jpeg", // JPEG images
  "image/jpg", // JPEG images
  "image/png", // Portable Network Graphics
  "image/bmp", // Windows OS/2 Bitmap Graphics
  "image/svg+xml", // Scalable Vector Graphics (SVG)
  "application/pdf", // Adobe Portable Document Format
  "application/vnd.ms-excel", // Microsoft Excel .xls
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // Microsoft Excel (OpenXML) .xlsx
  "application/vnd.ms-excel.sheet.macroEnabled.12", // Microsoft Excel .xlsm
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // Microsoft Word (OpenXML) .docx
  "application/msword", // Microsoft Word .doc
  "application/vnd.ms-powerpoint", // Microsoft PowerPoint .ppt
  "application/vnd.openxmlformats-officedocument.presentationml.presentation", // Microsoft PowerPoint (OpenXML) .pptx
  "text/plain",
  "text/csv", // Comma-separated values (CSV)
  "text/calendar", // iCalendar format .ics
  "application/json", // JSON format
  "audio/mpeg", // MP3 audio
  "audio/aac", // AAC audio	.aac
  "video/mp4", // MP4 video
  "video/mpeg", // MPEG Video
  "application/vnd.oasis.opendocument.presentation", // OpenDocument presentation document .odp
  "application/vnd.oasis.opendocument.spreadsheet", // OpenDocument spreadsheet document .ods
  "application/vnd.oasis.opendocument.text" // OpenDocument text document .odt
];

const extensionMap: Record<string, string[]> = {
  "image/jpeg": [".jpeg", ".jpg"],
  "image/jpg": [".jpg"],
  "image/png": [".png"],
  "image/bmp": [".bmp"],
  "image/svg+xml": [".svg"],
  "application/pdf": [".pdf"],
  "application/vnd.ms-excel": [".xls"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
  "application/vnd.ms-excel.sheet.macroEnabled.12": [".xlsm"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
  "application/msword": [".doc"],
  "application/vnd.ms-powerpoint": [".ppt"],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [".pptx"],
  "text/plain": [".txt"],
  "text/csv": [".csv"],
  "text/calendar": [".ics"],
  "application/json": [".json"],
  "audio/mpeg": [".mp3"],
  "audio/aac": [".aac"],
  "video/mp4": [".mp4"],
  "video/mpeg": [".mpeg"],
  "application/vnd.oasis.opendocument.presentation": [".odp"],
  "application/vnd.oasis.opendocument.spreadsheet": [".ods"],
  "application/vnd.oasis.opendocument.text": [".odt"]
};

export const acceptableFilesMap = acceptableFiles.reduce(
  (acc, mime) => {
    if (extensionMap[mime]) {
      acc[mime] = extensionMap[mime];
    } else {
      acc[mime] = []; // fallback if no extension known
    }
    return acc;
  },
  {} as Record<string, string[]>
);
